import Robot from './robotbase'


class RobotiqC2 extends Robot {
	constructor() {
		super('RobotiqC2', 'robotiq_2f_c2_gripper_visualization', 'urdf/robotiq_c2_model.xacro');

		this.robotRoot = 'robotiq_85_adapter_link';
		this.handRoot = 'robotiq_85_adapter_link';
		this.modelScale = 10;

		this.tcp.parent = 'robotiq_85_base_link';
		this.tcp.position = [0, 0, 0.13];
		this.hand.invertOpenClose = true;
	}
}

module.exports = new RobotiqC2();